export default {
    create_canned_command_create_title: "New Canned Command",
    create_canned_command_edit_title: "Edit Canned Command",
    create_canned_command_create_success_message: "The canned command has been created",
    create_canned_command_update_success_message: "The canned command has been edited",
    create_canned_command_manufacturer: "Manufacturer",
    create_canned_command_label: "Label",
    create_canned_command_command: "Command",
    create_canned_command_unit_type: "Unit Type",
    create_canned_command_via: "Via",
    create_canned_command_via_sms: "SMS",
    create_canned_command_via_ota: "OTA",
    create_canned_command_create_active: "Active",
    create_canned_command_create_inactive: "Inactive",
    create_canned_command_apply_to_all_types: "Apply to All Types"
}